import { Box, BoxProps, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { TooltipView } from '../../comps/TootTipView'

const styles = {
  container: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginVertical: 16,
    ph: 4,
  } as BoxProps,
  titleContainer: { flexDirection: 'row', alignItems: 'center' } as BoxProps,
  shadowStyle: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 2,
    shadowColor: 'GREY_MATTE',
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: 'BRAND_COLOR_GRAY_3',
    zIndex: 5,
    backgroundColor: 'WHITE',
  } as BoxProps,
}

interface TitleSubtitleLayoutProps {
  placeHolder?: string
  title?: string
  tooltip?: string
  top: number
}

const TitleSubTitleLayout: FC<TitleSubtitleLayoutProps> = ({
  placeHolder,
  title = '',
  tooltip,
  top,
}: TitleSubtitleLayoutProps) => {
  return (
    <Box {...styles.container}>
      <Text color={'BLACK_21'} fontSize={26} fontFamily={'jiotype-bold'}>
        {title}
      </Text>
      <Spacer direction={'vertical'} size={8} />
      <Box margin={0} padding={0} {...styles.titleContainer}>
        <Text color={'BLACK_75'} fontSize={14} fontFamily={'jiotype-medium'}>
          {placeHolder}
        </Text>
        {tooltip && <TooltipView value={tooltip} top={top} iconColor={'BLACK_75'}/>}
      </Box>
    </Box>
  )
}

export { TitleSubTitleLayout }
